<template>
    <div class="weather-widget">
        <div v-if="loadError" class="text-muted small">Não foi possível carregar a previsão do tempo.</div>
        <template v-else-if="today">
            <div class="weather-city">{{ city }}</div>
            <div class="weather-current">
                <span class="weather-current-icon">{{ iconFor(today.code) }}</span>
                <span class="weather-current-temps">
                    <span class="temp-max">{{ Math.round(today.max) }}°</span>
                    <span class="temp-min">{{ Math.round(today.min) }}°</span>
                </span>
            </div>
            <div class="weather-forecast">
                <div class="weather-day" v-for="day in nextDays" :key="day.date">
                    <span class="weather-day-name">{{ dayName(day.date) }}</span>
                    <span class="weather-day-temps">
                        <span class="temp-max">{{ Math.round(day.max) }}°</span>
                        <span class="temp-min">{{ Math.round(day.min) }}°</span>
                    </span>
                    <span class="weather-day-icon">{{ iconFor(day.code) }}</span>
                </div>
            </div>
            <div class="weather-footer text-muted">Dados: Open-Meteo</div>
        </template>
    </div>
</template>

<script>
import axios from "axios";

const WEATHER_ICONS = {
    0: '☀️',
    1: '🌤️',
    2: '⛅',
    3: '☁️',
    45: '🌫️',
    48: '🌫️',
    51: '🌦️',
    53: '🌦️',
    55: '🌦️',
    56: '🌧️',
    57: '🌧️',
    61: '🌧️',
    63: '🌧️',
    65: '🌧️',
    66: '🌧️',
    67: '🌧️',
    71: '🌨️',
    73: '🌨️',
    75: '🌨️',
    77: '🌨️',
    80: '🌦️',
    81: '🌦️',
    82: '🌧️',
    85: '🌨️',
    86: '🌨️',
    95: '⛈️',
    96: '⛈️',
    99: '⛈️'
};

export default {
    name: 'componentWeather',
    data() {
        return {
            city: 'São Paulo',
            latitude: -23.55,
            longitude: -46.63,
            days: [],
            loadError: false
        };
    },
    computed: {
        today() {
            return this.days[0] || null;
        },
        nextDays() {
            return this.days.slice(1, 4);
        }
    },
    mounted() {
        this.loadWeather();
    },
    methods: {
        async loadWeather() {
            try {
                const resp = await axios.get('https://api.open-meteo.com/v1/forecast', {
                    params: {
                        latitude: this.latitude,
                        longitude: this.longitude,
                        daily: 'temperature_2m_max,temperature_2m_min,weather_code',
                        timezone: 'America/Sao_Paulo',
                        forecast_days: 4
                    }
                });
                const daily = resp.data && resp.data.daily;
                if (!daily) {
                    this.loadError = true;
                    return;
                }
                this.days = daily.time.map((date, i) => ({
                    date,
                    max: daily.temperature_2m_max[i],
                    min: daily.temperature_2m_min[i],
                    code: daily.weather_code[i]
                }));
            } catch (error) {
                this.loadError = true;
            }
        },
        iconFor(code) {
            return WEATHER_ICONS[code] || '🌡️';
        },
        dayName(dateStr) {
            const name = new Date(dateStr + 'T12:00:00').toLocaleDateString('pt-BR', { weekday: 'long' });
            return name.replace('-feira', '').toUpperCase();
        }
    }
}
</script>

<style scoped>
.weather-widget {
    text-align: left;
}
.weather-city {
    font-size: 0.9rem;
    color: #63c2de;
    margin-bottom: 0.25rem;
}
.weather-current {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
}
.weather-current-icon {
    font-size: 2.5rem;
    line-height: 1;
    margin-right: 0.75rem;
}
.weather-current-temps {
    font-size: 1.75rem;
    font-weight: 500;
}
.temp-max {
    color: #f86c6b;
}
.temp-min {
    color: #63c2de;
    margin-left: 0.5rem;
}
.weather-forecast {
    border-top: 1px solid rgba(128, 128, 128, 0.25);
    padding-top: 0.5rem;
}
.weather-day {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.15rem 0;
    font-size: 0.85rem;
}
.weather-day-name {
    flex: 1;
    text-align: left;
    font-weight: 600;
    font-size: 0.7rem;
    opacity: 0.75;
}
.weather-day-temps {
    flex: 0 0 auto;
    margin-right: 0.5rem;
}
.weather-day-icon {
    font-size: 1.1rem;
}
.weather-footer {
    margin-top: 0.5rem;
    font-size: 0.7rem;
    text-align: right;
}
</style>
